import React from 'react'
import {connect} from 'react-redux'

import {
  GROUP_CHAT_SCOPES
} from '../shared/config/constants'

import bookmarkGroup from '../shared/data/setters/bookmark_group'
import unbookmarkGroup from '../shared/data/setters/unbookmark_group'

class ConversationMenuBookmarkItem extends React.Component {
  constructor (props) {
    super(props)

    this.bookmark = this.bookmark.bind(this)
    this.unbookmark = this.unbookmark.bind(this)
  }

  bookmark (e) {
    if (e && e.stopPropagation) e.stopPropagation()

    this.props.bookmarkGroup(this.props.currentUserUid, this.props.groupId)
  }

  unbookmark (e) {
    if (e && e.stopPropagation) e.stopPropagation()

    this.props.unbookmarkGroup(this.props.currentUserUid, this.props.groupId)
  }

  renderBookmarked () {
    return (
      <div className='sliding-menu-item report-user' onClick={this.unbookmark}>
        <i className='menu-item-icon rc-icon-bookmark'></i>
        Remove from My List
      </div>
    )
  }

  renderUnBookmarked () {
    return (
      <div className='sliding-menu-item report-user' onClick={this.bookmark}>
        <i className='menu-item-icon rc-icon-bookmark-outline'></i>
        Add to My List
      </div>
    )
  }

  render () {
    if (!this.props.currentUserUid) return false
    if (!this.props.groupChat) return false
    if (this.props.groupChat.get('scope') === GROUP_CHAT_SCOPES.GLOBAL) return false
    if (this.props.bookmarkedGroup) return this.renderBookmarked()

    return this.renderUnBookmarked()
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUserUid: state.getIn(['currentUser', 'uid']),
    groupChat: state.getIn(['groups', 'all', ownProps.groupId]),
    bookmarkedGroup: state.getIn(['groups', '_bookmarks', 'all', ownProps.groupId])
  }
}

const mapDispatchToProps = () => {
  return {
    bookmarkGroup: bookmarkGroup,
    unbookmarkGroup: unbookmarkGroup
  }
}

const ConversationMenuBookmarkItemContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ConversationMenuBookmarkItem)

export default ConversationMenuBookmarkItemContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversation_menu_bookmark_item.js
 **/